import { useEffect } from 'react'
import { dynamicGa4DataLayerPush } from '@which/shared'

import { Layout } from '../../layouts'
import type { RecommendedContentType, RecommendedModelType } from '../../models'
import { RecommendationsTextLinksLayout } from '../layouts/TextLinks/RecommendationsTextLinksLayout'
import { RecommendationsTwoByTwoLayout } from '../layouts/TwoByTwo/RecommendationsTwoByTwoLayout'

type RecommendationsProps = {
  content: RecommendedContentType[]
  whichId: string
  modelId: string
  layout: Layout
}

const Recommendations = ({ content, whichId, modelId, layout }: RecommendationsProps) => {
  useEffect(() => {
    dynamicGa4DataLayerPush({
      event: 'notification_ab_test',
      item_text: `${content.length}`,
      item_parent_text: modelId,
      item_group: 'R4U Recommendation Count',
    })
  }, [content, modelId])

  const title = 'Based on your interests'

  switch (layout) {
    case Layout.TwoByTwo:
      return (
        <RecommendationsTwoByTwoLayout
          content={content}
          title={title}
          whichId={whichId}
          modelId={modelId}
        />
      )

    case Layout.TextLinks:
      return (
        <RecommendationsTextLinksLayout
          content={content}
          title={title}
          whichId={whichId}
          modelId={modelId}
        />
      )

    default:
      console.warn(`The ${layout} is not defined for <Recommendations ... />`)
      return null
  }
}

interface ModelRecommendationsProps {
  model: RecommendedModelType | null
  whichId: string
  layout: Layout
}

export const ModelRecommendations = ({ model, whichId, layout }: ModelRecommendationsProps) => {
  const { content, model: modelId } = model ?? {}

  if (modelId && content && content.length > 0) {
    return <Recommendations content={content} whichId={whichId} modelId={modelId} layout={layout} />
  }

  return null
}
